import {
  initGlobalState
} from 'qiankun'

const initState = {
  name: 'main-app',
  currentBranchName:''
}

const actions = initGlobalState(initState)

export default actions